// extracted by mini-css-extract-plugin
export default {"page":"bZ-z","cartModal":"cZ-z","checkout":"dZ-z","placeholder":"eZ-z","account":"fZ-z"};